import React from 'react';

import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Row, Radio, Space, Tabs } from 'antd';
import { NextPage } from 'next';
import { FormattedMessage } from 'react-intl';
import { ITag } from 'src/shared/models';
import { useIntl } from 'react-intl';
import { OrderTagFilter } from 'src/shared/enums';
import { isChallengePage } from 'config/routes';
import { useRouter } from 'next/router';

interface OwnProps {
  pageClassName: string;
  filterComponent: JSX.Element;
  tabs: ITag[];
  order: number;
  handleChangeOrder;
  onChangeTab: (key: string) => void;
  onScroll;
  renderChallenges: (any) => JSX.Element | JSX.Element[];
  showMoreComponent: JSX.Element;
  challenges;
}

const CustomBuildPageChallenge: NextPage<OwnProps> = ({
  pageClassName,
  filterComponent,
  tabs,
  handleChangeOrder,
  order,
  onChangeTab,
  onScroll,
  renderChallenges,
  showMoreComponent,
  challenges,
}): JSX.Element => {
  const { pathname } = useRouter();
  const challengePage = isChallengePage(pathname);
  const { formatMessage } = useIntl();
  const { MOST_POPULAR, LEAST_TO_MOST_POINTS, MOST_TO_LEAST_POINTS } =
    OrderTagFilter;
  const orderMenu = () => {
    return (
      <Menu>
        <Menu.Item>
          <Radio.Group onChange={handleChangeOrder} value={order}>
            <Space direction="vertical">
              <Radio value={MOST_POPULAR}>
                <span className="order__break-line">
                  {formatMessage({
                    id: 'challenge.order.component.label.most-popular',
                  })}
                </span>
              </Radio>
              <Radio value={LEAST_TO_MOST_POINTS}>
                <span className="order__break-line">
                  {formatMessage({
                    id: 'challenge.order.component.label.least-to-most-points',
                  })}
                </span>
              </Radio>
              <Radio value={MOST_TO_LEAST_POINTS}>
                <span className="order__break-line">
                  {formatMessage({
                    id: 'challenge.order.component.label.most-to-least-points',
                  })}
                </span>
              </Radio>
            </Space>
          </Radio.Group>
        </Menu.Item>
      </Menu>
    );
  };
  return (
    <>
      <div className="challengePage__wrapperFiltersSticky">
        <div className={`container challengePage ${pageClassName}`}>
          {filterComponent}
          <div id="hided-by-filter" className="challengePage__filters">
            <div className="challengePage__containerFiltersDropdown">
              <Tabs
                defaultActiveKey={String(tabs[0].idTag)}
                animated={false}
                size="small"
                className="formationTabs"
                onTabClick={(key) => {
                  onChangeTab(String(key));
                  onScroll();
                }}>
                {tabs.map((tab) => (
                  <Tabs.TabPane
                    key={tab.idTag}
                    tab={
                      <div className="tabContainer">
                        <img
                          style={{ width: 21, height: 21, marginBottom: 9 }}
                          src={tab.image}
                        />
                        <div className="tabLabel">{tab.name}</div>
                      </div>
                    }></Tabs.TabPane>
                ))}
              </Tabs>
              {!challengePage && (
                <Dropdown
                  overlay={orderMenu}
                  className="orderMenuContainer"
                  overlayClassName="orderDropdownContainer">
                  <Space>
                    {formatMessage({
                      id: 'challenge.order.component.title',
                    })}
                    <DownOutlined />
                  </Space>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`container challengePage ${pageClassName}`}>
        <Row
          className="challengePage__challenges-row"
          justify="start"
          gutter={[12, 24]}>
          {renderChallenges(challenges)}
        </Row>
        {showMoreComponent}
      </div>
    </>
  );
};

export default CustomBuildPageChallenge;

export const showMoreButton = (
  label: string,
  isLoading: boolean,
  hasMore: boolean,
  fetch: () => Promise<void>,
): JSX.Element => {
  if (isLoading) return <LoadingOutlined />;

  return (
    hasMore && (
      <Row justify="center" style={{ padding: '1cm 0' }}>
        <Button
          className="show-more btn-ghost btn-ghost--minimalist remove-right-space"
          loading={isLoading}
          onClick={fetch}>
          <Row justify="center" align="middle">
            <p>
              <FormattedMessage id={label} />
            </p>
            <a className={`icon icon--arrow-dropdown-down icon__reduce_75`} />
          </Row>
        </Button>
      </Row>
    )
  );
};
